export interface Role {
  label: string;
  value: Roles;
}

export enum Roles {
  SUPER_ADMIN = 'super_admin',
  ADMIN = 'admin',
}

export const roleOpts: Role[] = [
  {value: Roles.SUPER_ADMIN, label: 'Super Admin'},
  {value: Roles.ADMIN, label: 'Admin'},
];
